/**
 * Ob eine Komponente noch im Baum steht - als Ref, nicht als State. Ein Upload oder eine Anfrage laeuft
 * Minuten; wenn sie endet, braucht der Aufrufer den Stand von JETZT (steht die Flaeche noch?), nicht den der
 * Ausfuehrung, in der sie startete.
 *
 * Der Block stand fuenffach: in `DokumenteTab.tsx`, `Positionsdokumente.tsx` und `SammelsendungDrawer.tsx` (dort
 * ausgezogen im Aufraeumzweig nach "Uploads bis 100 MB", Task 7) sowie in `App.tsx` (`istEingehaengt`) und
 * `useDrawerTasks.ts`; eine einzige Fassung statt fuenf Abschriften. Der Haken ist allgemein und kennt keine dieser
 * Komponenten. Die App-Stellen (`App.tsx` selbst sowie `useDrawerTasks`, `useDrawerSpedition` und `useDrawerZahlungen`)
 * nehmen `"passiv"`: sie werden nur zusammen mit `Anwendung` abgebaut (die drei Hooks werden in `App.tsx` aufgerufen) -
 * mit der ganzen Seite oder wenn die `FehlerGrenze`
 * (`src/App.tsx`) nach einem Absturz ihre Ersatzanzeige zeigt. Der Zeitpunkt spielt dort keine Rolle, und
 * `"passiv"` haelt das bisherige Verhalten.
 *
 * ZWEI ZEITPUNKTE, `abbau` ist Pflicht. Baut eine Router-Transition (Reiterwechsel, In-App-Navigation) oder ein Update
 * ausserhalb eines Ereignisses die Flaeche ab, fuehrt React den passiven Cleanup erst in einer SPAETEREN Scheduler-Aufgabe
 * aus (nur ein Commit auf der Sync-Lane tut es sofort - auch ein echtes Vor/Zurueck des Browsers, das React 19 eager auf
 * der Sync-Lane rendert). Dazwischen sind die DOM-Knoten schon weg, die Ref waere noch wahr:
 * endet ein Upload in diesem Fenster, landete sein Ergebnis im State der toten Instanz und ginge verloren.
 *   `"layout"`  die Ref wird im SELBEN Schritt falsch wie die uebrigen Layout-Cleanups der Komponente, also im Commit, der
 *               die Knoten entfernt. REGEL: wer an der Ref entscheidet, ob es noch eine sichtbare Flaeche gibt (eigene
 *               Zeile oder stehender Hinweis), nimmt `"layout"` - so `DokumenteTab`, `Positionsdokumente` und
 *               `SammelsendungDrawer`. `DokumenteTab` hat zusaetzlich den Dialog-Grund: sie muss im selben Schritt falsch
 *               werden wie der Aufraeumschritt ihrer Dialoge - sonst oeffnet ein Duplikat-Treffer dazwischen einen
 *               Dialog an der abgebauten Instanz, und die Sperre geht nie auf.
 *   `"passiv"`  die Ref wird erst im passiven Cleanup falsch, also nach den Layout-Cleanups. Nur dort, wo der Zeitpunkt
 *               keine Rolle spielt (die App-Stellen).
 *
 * Beide Effekt-Hooks werden bei jedem Aufruf gerufen (Rules of Hooks), nur der zu `abbau` passende tut etwas.
 */
import { useEffect, useLayoutEffect, useRef } from "react";

export function useMontiertRef(abbau: "layout" | "passiv"): { readonly current: boolean } {
  const montiertRef = useRef(true);
  useLayoutEffect(() => {
    if (abbau !== "layout") return;
    montiertRef.current = true;
    return () => {
      montiertRef.current = false;
    };
  }, [abbau]);
  useEffect(() => {
    if (abbau !== "passiv") return;
    montiertRef.current = true;
    return () => {
      montiertRef.current = false;
    };
  }, [abbau]);
  return montiertRef;
}
